import React, { useState } from "react";
import {
  Container,
  Header,
  Form,
  FormField,
  Input,
  Button,
  SpaceBetween,
  Alert,
} from "@cloudscape-design/components";
import { useNavigate } from "react-router-dom";
import { AUTH_API } from "../config/api";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email) {
      setError("Veuillez entrer votre adresse email.");
      return;
    }

    try {
      setLoading(true);
      const res = await fetch(AUTH_API.resetPasswordRequest, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(data.message || "Si un compte existe avec cet email, un lien de réinitialisation sera envoyé.");
      } else {
        setError(data.message || "Erreur lors de la demande.");
      }
    } catch (err) {
      setError("Erreur réseau. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      <div className="forgot-password-bg-image" aria-hidden="true">
        <img src={`${process.env.PUBLIC_URL}/backgroundhero.png`} alt="" />
      </div>
      <div className="forgot-password-overlay" aria-hidden="true" />

      <div className="forgot-password-header">
        <img src="/logoadexcloud.png" alt="Adexgénie" className="forgot-password-logo" />
        <div className="forgot-password-title">Reset your password</div>
        <div className="forgot-password-subtitle">
          Enter your email and we'll send you a secure link to reset your password.
        </div>
      </div>

      <div className="forgot-password-form-overlay">
        <div className="forgot-password-form-card">
          <Container
            header={
              <Header variant="h1">
                Forgot password
                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#5f6b7a', display: 'block', marginTop: '4px' }}>
                  Request a reset link
                </span>
              </Header>
            }
          >
            <SpaceBetween size="l" direction="vertical">
              {error && <Alert type="error">{error}</Alert>}
              {success && <Alert type="success">{success}</Alert>}
              <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                <Form
                  actions={
                    <SpaceBetween direction="vertical" size="s">
                      <Button
                        formAction="submit"
                        variant="primary"
                        loading={loading}
                        fullWidth
                      >
                        Send reset link
                      </Button>
                      <Button variant="link" onClick={() => navigate("/signin")}>
                        Back to sign in
                      </Button>
                    </SpaceBetween>
                  }
                >
                  <FormField
                    label="Email"
                    description="Enter the email address associated with your account"
                  >
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.detail.value)}
                      placeholder="you@example.com"
                      disabled={loading}
                    />
                  </FormField>
                </Form>
              </form>
            </SpaceBetween>
          </Container>
        </div>
      </div>

    </div>
  );
};

export default ForgotPassword;
